import * as React from 'react';
import { QueryClient } from 'react-query';
import { identity, pickBy } from 'lodash';
import ModelContext, { createModelStore } from './ModelContext';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    }
  }
});
export default function ModelProvider({
  children,
  // IModelContextProps
  env,
  keyEnv,
  keyAuthToken,
  socket,
  // QueryClientProvider
  queryClient = defaultQueryClient
}) {
  const storeRef = React.useRef();
  if (!storeRef.current) {
    storeRef.current = createModelStore(pickBy({
      env,
      keyEnv,
      keyAuthToken,
      socket,
      queryClient
    }, identity));
  }
  if (!storeRef.current) {
    return null;
  }
  return /*#__PURE__*/_jsx(ModelContext.Provider, {
    value: storeRef.current,
    children: children
  });
}